import React from 'react';
import { TextInput } from '../ui/TextInput';
import { AptitudesInfoBlock } from '../AptitudesInfoBlock';

export interface AptitudesValues {
  readonly actividad_profesion: string;
  readonly habilidad_talento: string;
}

interface MiembroFieldsAptitudesProps {
  readonly values: AptitudesValues;
  readonly onFieldChange: (field: keyof AptitudesValues, value: string) => void;
  readonly errors: Record<string, string>;
  readonly required?: boolean;
}

export const MiembroFieldsAptitudes: React.FC<MiembroFieldsAptitudesProps> = ({
  values, onFieldChange, errors, required = false,
}) => (
  <div className="space-y-4">
    <TextInput label="Profesión u oficio"
      value={values.actividad_profesion} onChange={(v) => onFieldChange('actividad_profesion', v)}
      error={errors.actividad_profesion} required={required} />
    <TextInput label="Habilidad o talento"
      value={values.habilidad_talento} onChange={(v) => onFieldChange('habilidad_talento', v)}
      error={errors.habilidad_talento} required={required} />
    <AptitudesInfoBlock />
  </div>
);
